var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6229 36.8575L6.48113 30.6325C5.93855 30.3754 5.93855 29.6034 6.48113 29.3464L19.6229 23.1213C19.8135 23.031 20.0343 23.0299 20.2257 23.1183L33.7133 29.3434C34.2645 29.5977 34.2645 30.3811 33.7133 30.6355L20.2257 36.8605C20.0343 36.9489 19.8135 36.9478 19.6229 36.8575Z",
    fill: "#C71616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2584 8.66085L11.1247 28.5954C10.7915 29.6785 11.1544 30.8432 12.1909 31.3011C13.6701 31.9546 16.228 32.7158 20.118 32.7158C23.9886 32.7158 26.5404 31.9622 28.023 31.3109C29.0715 30.8503 29.4329 29.6698 29.0833 28.5793L22.6891 8.62917C21.8388 5.97637 18.0777 5.99832 17.2584 8.66085Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0983 15.689L13.5221 20.8115C13.619 20.8337 13.7208 20.8561 13.8277 20.8786C15.0839 21.143 17.0429 21.421 19.7311 21.421C22.4194 21.421 24.3784 21.143 25.6346 20.8786C25.9966 20.8023 26.3008 20.7272 26.5476 20.6599L24.9292 15.6108C23.5587 15.8142 21.8286 15.9681 19.7311 15.9681C17.9123 15.9681 16.3698 15.8524 15.0983 15.689ZM16.2631 11.9035C17.2415 12.0048 18.3964 12.0734 19.7311 12.0734C21.3118 12.0734 22.6403 11.9773 23.722 11.8443L21.3086 4.31441C20.8835 2.98801 19.0029 2.99899 18.5933 4.33025L16.2631 11.9035ZM10.8528 29.4871L12.3742 24.5422C12.5744 24.591 12.7914 24.6405 13.0254 24.6898C14.5442 25.0095 16.7721 25.3158 19.7311 25.3158C22.6902 25.3158 24.9181 25.0095 26.4369 24.6898C26.9523 24.5813 27.3854 24.4714 27.7372 24.3716L29.3742 29.479C29.5489 30.0242 29.3739 30.6148 28.8733 30.8927C27.6342 31.5807 24.8704 32.7157 20.1205 32.7157C15.357 32.7157 12.5909 31.5742 11.3571 30.8868C10.8622 30.6111 10.6861 30.0286 10.8528 29.4871Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSign);
export default __webpack_public_path__ + "static/media/warningSign.f51b7110d736bbf3fd7a54ac69b82012.svg";
export { ForwardRef as ReactComponent };